export default __webpack_public_path__ + "static/LORDRARE-ef1d1bdb7f785a759c447a7e958d0486.jpg";